<mat-toolbar class="mat-elevation-z8">
  {{ i18n.title | translateAttribute }}
</mat-toolbar>

<mat-dialog-content>
  <div class="container">
    @if (data.problemDevices && data.problemDevices.length > 0) {
      <div>
        <div class="device-list">
          @for (device of data.problemDevices; track device) {
            <div class="device-row">
              <div class="status-dot" [ngClass]="device.isUp ? 'status-up' : 'status-down'"></div>
              <div class="device-info">
                <div class="device-name">{{device.name}}</div>
                <div class="device-status">
                  @if (!device.isUp) {
                    <span>{{ i18n.offline | translateAttribute }}</span>
                  }
                  @if (device.isUp && onlineSinceMinutesAgo(device) != null) {
                    <span>
                      {{ i18n.onlineFor | translateAttribute }} {{onlineSinceMinutesAgo(device)}} {{ i18n.min | translateAttribute }}
                    </span>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="no-devices-container">
        <p>{{ i18n.noDevices | translateAttribute }}</p>
      </div>
    }

  </div>
</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" align="end">
  <button mat-button mat-dialog-close>{{ i18n.close | translateAttribute }}</button>
</mat-dialog-actions>
